import { render, staticRenderFns } from "./EditStudySet.vue?vue&type=template&id=c7973418&scoped=true&"
import script from "./EditStudySet.vue?vue&type=script&lang=js&"
export * from "./EditStudySet.vue?vue&type=script&lang=js&"
import style0 from "./EditStudySet.vue?vue&type=style&index=0&id=c7973418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7973418",
  null
  
)

export default component.exports